var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 46,
    fill: "none",
    viewBox: "0 0 56 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.667 21.5c0 4.28-3.433 7.75-7.667 7.75s-7.667-3.47-7.667-7.75c0-4.28 3.433-7.75 7.667-7.75s7.667 3.47 7.667 7.75Zm-3.834 0c0 2.14-1.716 3.875-3.833 3.875s-3.833-1.735-3.833-3.875c0-2.14 1.716-3.875 3.833-3.875s3.833 1.735 3.833 3.875Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.917 6A1.927 1.927 0 0 0 5 7.938v27.125C5 36.133 5.858 37 6.917 37h42.166A1.927 1.927 0 0 0 51 35.062V7.939A1.927 1.927 0 0 0 49.083 6H6.917Zm1.916 19.375v-7.75c4.235 0 7.667-3.47 7.667-7.75h23c0 4.28 3.432 7.75 7.667 7.75v7.75c-4.235 0-7.667 3.47-7.667 7.75h-23c0-4.28-3.432-7.75-7.667-7.75Zm0 3.875v3.875h3.834c0-2.14-1.717-3.875-3.834-3.875Zm38.334-15.5c-2.117 0-3.834-1.735-3.834-3.875h3.834v3.875Zm-3.834 19.375h3.834V29.25c-2.117 0-3.834 1.735-3.834 3.875ZM12.667 9.875c0 2.14-1.717 3.875-3.834 3.875V9.875h3.834Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M35.667 21.5c0 4.28-3.433 7.75-7.667 7.75s-7.667-3.47-7.667-7.75c0-4.28 3.433-7.75 7.667-7.75s7.667 3.47 7.667 7.75Zm-3.834 0c0 2.14-1.716 3.875-3.833 3.875s-3.833-1.735-3.833-3.875c0-2.14 1.716-3.875 3.833-3.875s3.833 1.735 3.833 3.875Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M6.917 6A1.927 1.927 0 0 0 5 7.938v27.125C5 36.133 5.858 37 6.917 37h42.166A1.927 1.927 0 0 0 51 35.062V7.939A1.927 1.927 0 0 0 49.083 6H6.917Zm1.916 19.375v-7.75c4.235 0 7.667-3.47 7.667-7.75h23c0 4.28 3.432 7.75 7.667 7.75v7.75c-4.235 0-7.667 3.47-7.667 7.75h-23c0-4.28-3.432-7.75-7.667-7.75Zm0 3.875v3.875h3.834c0-2.14-1.717-3.875-3.834-3.875Zm38.334-15.5c-2.117 0-3.834-1.735-3.834-3.875h3.834v3.875Zm-3.834 19.375h3.834V29.25c-2.117 0-3.834 1.735-3.834 3.875ZM12.667 9.875c0 2.14-1.717 3.875-3.834 3.875V9.875h3.834Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 55,
    height: 40,
    x: 0.5,
    y: 5.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_358",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.264388ee9b31ab0dd73129eb66554bbf.svg";
export { ForwardRef as ReactComponent };